<div class="container-fluid justify-content-center mb-0 pt-1 pb-0 shadow-lg col-12">
  <div class="jumbotron-fluid mx-0 px-0 my-0 pt-1 pb-0">
    <div class="container mt-2 mb-0 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Users Reports
          </h3>
        </div>
      </div>
    </div>
    <div class="search-container container mx-auto px-0 my-0 py-0 col-12">
      <div class="d-flex my-0 py-0 mx-auto px-auto">
        <div class="col-12 mx-0 px-3 px-sm-2 px-lg-3">
          <form [formGroup]="userForm">
            <div class="row">
              <div class="col-12 mx-0 px-0 px-sm-1 pt-1">
                <div class="row align-content-center">
                  <div class="col-6 col-md-4 col-lg-4">
                    <select
                      formControlName="report_type"
                      class="form-control"
                      autocomplete="off"
                      placeholder="Specify Type"
                      (change)="changeReport(userForm.controls.report_type.value)"
                    >
                      <option selected>Specify Type</option>
                      <option *ngFor="let report of [
                          'All Users',
                          'Approved Users',
                          'Pending Users'
                        ]; let i = index">
                        {{ report }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6 col-md-4 col-lg-4 d-flex flex-row">
                    <div class="input-group mb-0">
                      <input
                        id="range_date"
                        formControlName="range_date"
                        type="text"
                        class="form-control"
                        placeholder="Select date range"
                        autocomplete="off"
                        bsDaterangepicker [bsConfig]="{
                           containerClass: 'theme-blue',
                           dateInputFormat: 'MM/DD/YYYY',
                           isAnimated: true
                         }"
                        placement="bottom"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-4 col-lg-4">
                    <app-search
                      [data]="getReportsCopy()"
                      [type]="type"
                      (searchResult)="searchResponse($event)"
                    ></app-search>
                  </div>
                  <div class="col-6 col-md-2 col-lg-2 mt-md-1 mt-lg-1">
                    <select
                      formControlName="search_by"
                      class="form-control"
                      autocomplete="off"
                      placeholder="Select a level"
                      (change)="changeLevels(userForm.controls.search_by.value)"
                    >
                      <option selected value="General">All Locations</option>
                      <option>Region</option>
                      <option>Town</option>
                      <option>Station</option>
                    </select>
                  </div>
                  <div class="col-6 col-md-3 col-lg-3 mt-md-1 mt-lg-1">
                    <select
                      formControlName="location"
                      class="form-control"
                    >
                      <option selected [value]="null">
                        {{ level ? level == 'General' ? "All locations report" :  'Select a ' + level : "All locations report" }}
                      </option>
                      <option
                        *ngFor="let item of locations"
                        [value]="level === 'Region' ? item.theAreaLocationId
                                : level === 'Town' ? item.theTownLocationId
                                : item.theStationLocationId"
                      >
                        {{ level === "Region" ? item.areaRegionName : level === "Town"
                        ? item.townName : item.stationName
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6 col-md-3 col-lg-3 my-auto">
                    <!-- layout spacer-->
                  </div>
                  <div class="col-6 col-md-4 col-lg-4 d-flex flex-row my-auto">
                    <button
                      class="btn btn-info col-5"
                      type="button"
                      (click)="fetchReport()"
                    > Get Report</button>
                    <app-export-btn [type]="type"></app-export-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row d-flex mt-1">
            <mat-paginator
              class="ml-md-auto"
              [length]="singleReport?.length"
              [pageSize]='pageSize'
              (page)="getPaginatorData($event)"
              [pageSizeOptions]="pageSizeOptions()"
              showFirstLastButtons="true"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--card for displaying Approved Users Report-->
<div *ngIf="type === 'All Users' && singleReport" [id]="type">
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          All Users Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-3">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">User Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.userPhotoUrl"
                  (click)="openModal(template, itm.userPhotoUrl)"
                />
                <label class="pic-font">ID Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.idPhotoUrl"
                  (click)="openModal(template, itm.idPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11 pt-xl-2">
                <app-users-report [itm]="itm"></app-users-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- all Approved Users reports -->
<div *ngIf="type === 'Approved Users' && singleReport" [id]="type">
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Approved Users Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-3">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              ">
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">User Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.userPhotoUrl"
                  (click)="openModal(template, itm.userPhotoUrl)"
                />
                <label class="pic-font">ID Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.idPhotoUrl"
                  (click)="openModal(template, itm.idPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11 pt-xl-2">
                <app-users-report [itm]="itm"></app-users-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- all Pending Users -->
<div *ngIf="type === 'Pending Users' && singleReport" [id]="type">
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Pending Users Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-3">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">User Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.userPhotoUrl"
                  (click)="openModal(template, itm.userPhotoUrl)"
                />
                <label class="pic-font">ID Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.idPhotoUrl"
                  (click)="openModal(template, itm.idPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11 pt-xl-2">
                <app-users-report [itm]="itm"></app-users-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header bg-info">
    <!-- <h4 class="modal-title text-white">
                              Client's Image
                            </h4> -->

    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 d-flex justify-content-center">
      <pinch-zoom>
        <img
          class="modal-img mx-auto mt-3 mt-md-2 mb-1 pb-0"
          [src]="imageUrl"
        />
      </pinch-zoom>
    </div>
  </div>
</ng-template>
